import Vue from "vue";

// axios
import axios from "axios";

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: "https://api.p2cargo.com/api",
  //  baseURL: 'http://127.0.0.1:4445/api',
  // timeout: 1000,//
  // headers: {'X-Custom-Header': 'foobar'}
});

// รูปแชท/ไฟล์อยู่บน server จริง — ตอน dev ชี้ API local แต่ media ยังโหลดจาก production
export const mediaBaseURL = 'https://api.p2cargo.com/api'

Vue.prototype.$http = axiosIns;

export default axiosIns;
